module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/imprint.json
// module id = 464
// module chunks = 156392403559710